import "../../stylesheets/App.css";
import "../../stylesheets/PopupRegister.css";
import "../../stylesheets/LoaderGame.css";
import React from "react";

function LoaderGame() {
  return (
    <>
      <div className="popup-register-container loadergame-full-container">
        <div className="loader-container">
          <img
            className="intro-loader"
            src={process.env.PUBLIC_URL + "/images/intro/spinner.webp"}
            alt="Cargando..."
          />
        </div>
      </div>
    </>
  );
}

export default LoaderGame;
